import React from 'react';
import Icon from './Icon';

export default class IconCopy extends Icon {

    // renderIcon() {
    //     const color = this.props.color ? this.props.color : (this.state.hover ? '#ec6b05' : '#A6ACAF')
    //     return (
    //         <svg width={this.getSize()} height={this.getSize()} viewBox="0 0 9 8">
    //             <path fill={color} fillRule="nonzero" d="M4.772 5.468L2.134 8.106.772 6.744l2.639-2.638L.772 1.468 2.134.106l2.638 2.638L7.411.106l1.361 1.362-2.638 2.638 2.638 2.638-1.361 1.362-2.639-2.638z"/>
    //         </svg>
    //     )
    // }

    renderIcon() {
        const color = this.props.color ? this.props.color : (this.state.hover ? '#ec6b05' : '#A6ACAF')

        return (

            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                <g fill="none" fillRule="nonzero">

                    <path fill={color} fillRule="nonzero"
                          d="M10.576 0H2.374c-.752 0-1.367.573-1.367 1.273v8.909h1.367v-8.91h8.202V0zm2.05 2.545H5.108c-.752 0-1.367.573-1.367 1.273v8.91c0 .7.615 1.272 1.367 1.272h7.518c.752 0 1.367-.573 1.367-1.273V3.818c0-.7-.615-1.273-1.367-1.273zm0 10.182H5.108V3.818h7.518v8.91z"/>
                </g>
            </svg>
        );


    }
}